/** Static cavern scenery. Ceiling templates use the shared underside-support
 * contract: authored y is still the sprite bottom, so y - height meets the roof.
 * Columns remain behind terrain; none of this art supplies collision or light. */
export const CAVERN_PROP_TEMPLATES = {
  hanging_root: { kind: 'fallen_log', name: 'Trailing cavern taproot', frame: { w: 80, h: 192 }, band: 'architecture', attachment: 'ceiling' },
  ceiling_stalactite: { kind: 'moor_stone', name: 'Split mineral stalactites', frame: { w: 72, h: 144 }, band: 'architecture', attachment: 'ceiling' },
  spore_pod: { kind: 'bioluminescent_fungus', name: 'Mosslight spore pods', frame: { w: 64, h: 72 }, band: 'vegetation' },
  // This narrow central bark strip is fully opaque in the unchanged SVG;
  // expanded-frame raster tests cover every pixel at 1x through 4x.
  hollow_root_column: { kind: 'gnarled_tree', name: 'Hollow branching root column', frame: { w: 144, h: 288 }, band: 'architecture',
    wallRegions: [{ x: 62, y: 124, width: 12, height: 40 }] },
} as const;

export type CavernPropTemplate = keyof typeof CAVERN_PROP_TEMPLATES;

/** Copyable explicit palettes. Violet is a narrow accent on pod seams; cyan
 * and moss remain quiet painted colors, with no bloom/filter or animation. */
export const CAVERN_PROP_PALETTES = {
  mosslight: {
    primary: '#485b43', shade: '#172c26', roof: '#243c35', roofEdge: '#89778c',
    wood: '#3e4032', woodEdge: '#797b59', stone: '#5a7168', iron: '#13251f',
    glass: '#77a185', glassCore: '#b1c5a1',
  },
  deepwater: {
    primary: '#3e5554', shade: '#152c31', roof: '#273d46', roofEdge: '#9781a3',
    wood: '#353d3c', woodEdge: '#73827a', stone: '#647d83', iron: '#11232a',
    glass: '#6c9d9e', glassCore: '#a3c7c3',
  },
} as const;
